export const DEFAULT_CHUNK_SIZE = 4;

const CTA_BLOCKS = [
  "call_to_action_small",
  "call_to_action",
  "call_to_action_right",
];
const IGNORE_BLOCKS = [...CTA_BLOCKS, "services_slider", "jobs"];

const hasCallToActionSlice = (slices: any) =>
  slices.some((slice: any) => CTA_BLOCKS.includes(slice.slice_type));

const shouldAddCallToAction = (slices: any, chunkSize = DEFAULT_CHUNK_SIZE) =>
  // Ignore all slices that are in the IGNORE_BLOCKS array and make sure more than 3 are left
  slices.filter((slice: any) => !IGNORE_BLOCKS.includes(slice.slice_type))
    .length >= chunkSize;

const addSmallCallToActions = (
  slices: any,
  globalSettings: any,
  chunkSize = DEFAULT_CHUNK_SIZE
) => {
  if (chunkSize === 0 || !shouldAddCallToAction(slices, chunkSize)) {
    return slices;
  }

  const ctaSlice = globalSettings?.data?.slices?.filter(
    (slice: any) => slice.slice_type === "call_to_action_small"
  )[0];

  return (
    slices
      // Split slices into chunks of 4
      .reduce((acc: any, slice: any, i: number) => {
        const index = Math.floor(i / chunkSize);
        if (!acc[index]) {
          acc[index] = [];
        }
        acc[index].push(slice);
        return acc;
      }, [])
      // Add the call to actions
      .map((chunk: any, j: number) => {
        if (chunk.length === chunkSize && !hasCallToActionSlice(chunk)) {
          // Add an element in the middle of the chunk
          const index = Math.floor(chunk.length / 2);
          chunk.splice(index, 0, {
            ...ctaSlice,
            id: `${ctaSlice.id}-${j}`,
          });
        }
        return chunk;
      })
      // Flatten the chunks
      .flat()
  );
};

export const fixCallToActions = (
  slices: any,
  globalSettings: any,
  chunkSize = DEFAULT_CHUNK_SIZE
) => {
  // Add small CTA for each chunk of slices
  const fixedSlices = addSmallCallToActions(slices, globalSettings, chunkSize);

  // Check if small CTA has been added
  const hasAddedCTA = fixedSlices.some(
    (slice: any) => slice.slice_type === "call_to_action_small"
  );

  return (
    fixedSlices
      // If no CTA has been added, make the existing CTA's a form
      .map((slice: any) => {
        if (!hasAddedCTA && slice.slice_type === "call_to_action") {
          return {
            ...slice,
            variation: "form",
          };
        }
        return slice;
      })
  );
};
